<template>
    <v-data-table
        :headers="headers"
        :items="list"
        dense
        :options="options"
        @update:options="updateOptions"
        :footer-props="footer"
        :server-items-length="length"
        :loading="loading"
    >
        <template v-slot:[`item.name`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.measure_unit.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.name}}
        </template>

    </v-data-table>
</template>

<script>
import permission from './../../data/permissions'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "MeasureUnitList",
    data() {
        return {
            headers: [
                { text: "Name", value: "name" },
                { text: "Abbreviation", value: "abbreviation" },
            ],
            footer: {
                'items-per-page-options': [5, 10, 15]
            },
            perm: permission
        }
    },
    computed : {
        ...mapGetters({
            list: "warehouse/measureUnit/list/data",
            options: "warehouse/measureUnit/list/options",
            loading: "warehouse/measureUnit/list/loading",
            length: "warehouse/measureUnit/list/length",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "warehouse/measureUnit/list/updateOptions"
        }),
        handleClickRow(item){  
            this.$router.push({ name: 'MeasureUnitDisplay', params: { id: item.id}})
        }
    }
}
</script>

<style>
</style>